import React from 'react';
import coverbackground from '../../assets/mask-up.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollMaskup extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        
        description="Mask up!"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollMaskup;